module.exports = __webpack_public_path__ + "img/backgroundImg.52a5b7c.webp";